import { rootReducer } from '../index';

type RootState = ReturnType<typeof rootReducer>;

export const euroRate = (state: RootState): number => Number(state.firestoreGlobalVariables.euroToUahRate);

export const globalVariables = (state: RootState) => state.firestoreGlobalVariables;

export const selectTermsOfConditions = (state: RootState) => state.firestoreGlobalVariables.terms_of_conditions;
